module.exports = __webpack_public_path__ + "static/Find Us Store 1-01-45802494f654f4a4c46bdf1cd91dfa19.png";